import { Image, ScrollView, StyleSheet, Text, View } from 'react-native';
import React, { FC, ReactNode, useCallback, useEffect, useState } from 'react';
import { Modal } from 'react-native';
import { TouchableOpacity } from 'react-native';
import { Button } from '../../../components/Button';
import { STYLE_VARS } from '../../../constants/style-vars';
import { COLORS, FONTS } from '../../../constants';
import UsersApi from '../../../services/api/user.api';
import { IUser } from '../../../types/auth.types';
import { UserItem } from './UserItem';
import { useIsDesktop } from '../../../hooks/useIsDeskTop';
import { SCREEN_WITDH } from '../../../constants/platform';
import { url } from 'inspector';
import { Loading } from '../../../components';

interface StaffPopupProps {
  setIsModalVisible: React.Dispatch<React.SetStateAction<boolean>>;
  isModalVisible: boolean;
  handleCreateChat: (id: number) => void;
}

const StaffPopup: FC<StaffPopupProps> = ({
  isModalVisible,
  setIsModalVisible,
  handleCreateChat,
}) => {
  const isDesktop = useIsDesktop();
  const [loading, setLoading] = useState<boolean>(false);
  const [users, setUsers] = useState<IUser[]>([]);
  const [offlineUser, setOfflineUser] = useState<IUser[]>([]);

  const handleClose = () => {
    setIsModalVisible(false);
  };

  const getOnlineStaff = useCallback(async () => {
    setLoading(true);
    UsersApi.getUsers({ staff: 1, is_online: 1 })
      .then((res) => {
        const onlineUsers = res.data.data.data;
        setUsers(onlineUsers);

        UsersApi.getUsers({ staff: 1 }).then((res1) => {
          const offUsers = res1.data.data.data.filter(
            (userItem) =>
              !onlineUsers.some((onlineUser) => onlineUser.id === userItem.id)
          );

          setOfflineUser(offUsers);
        });
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [setLoading]);

  useEffect(() => {
    if (isModalVisible) {
      getOnlineStaff();
    }
  }, [getOnlineStaff, isModalVisible]);

  return (
    <Modal visible={isModalVisible} animationType="fade" transparent={true}>
      <View style={styles.container}>
        <View style={styles.modalContainer}>
          <View
            style={{
              width: isDesktop() ? 400 : SCREEN_WITDH * 0.9,
            }}
          >
            <View
              style={{
                paddingHorizontal: 15,
                paddingVertical: 10,
                borderBottomWidth: 1,
                borderBottomColor: COLORS.LGREY,
                position: 'relative',
              }}
            >
              <Text
                style={{
                  fontFamily: FONTS.AvenirMedium,
                  fontWeight: '800',
                  fontSize: 19,
                  color: COLORS.BLACK,
                }}
              >
                {'ONLINE STAFF'}
              </Text>
              <TouchableOpacity
                style={{ position: 'absolute', right: 10, top: 10 }}
                onPress={() => {
                  handleClose();
                }}
              >
                <Image
                  style={{ width: 20, height: 20 }}
                  source={require('../../../assets/close-circle-icon.png')}
                />
              </TouchableOpacity>
            </View>
            <View style={{ minHeight: 50 }}>
              <ScrollView
                style={{
                  maxHeight: 230,
                }}
              >
                {loading && (
                  <View style={{ padding: 10 }}>
                    <Loading />
                  </View>
                )}
                {!loading && users.length === 0 && (
                  <View style={{ padding: 10 }}>
                    <Text
                      style={{
                        fontFamily: FONTS.AvenirRegular,
                        fontWeight: '500',
                        fontSize: 14,
                        textAlign: 'center',
                        color: COLORS.BLACK,
                      }}
                    >
                      THERE ARE CURRENTLY NO ONLINE STAFF
                    </Text>
                  </View>
                )}
                {!loading &&
                  users.length > 0 &&
                  users.map((user) => (
                    <UserItem
                      user={user}
                      handleCreateChat={(id) => {
                        handleCreateChat(id);
                        setIsModalVisible(false);
                      }}
                      isOnline={true}
                    />
                  ))}
              </ScrollView>
            </View>
            <View
              style={{
                paddingHorizontal: 15,
                paddingVertical: 10,
                borderBottomWidth: 1,
                borderBottomColor: COLORS.LGREY,
                position: 'relative',
              }}
            >
              <Text
                style={{
                  fontFamily: FONTS.AvenirMedium,
                  fontWeight: '800',
                  fontSize: 19,
                  color: COLORS.BLACK,
                }}
              >
                {'ALL STAFF'}
              </Text>
            </View>
            <View style={{ minHeight: 50, paddingBottom: 10 }}>
              <ScrollView
                style={{
                  maxHeight: 230,
                }}
              >
                {loading && (
                  <View style={{ padding: 10 }}>
                    <Loading />
                  </View>
                )}
                {!loading && offlineUser.length === 0 && (
                  <View style={{ padding: 10 }}>
                    <Text
                      style={{
                        fontFamily: FONTS.AvenirRegular,
                        fontWeight: '500',
                        fontSize: 14,
                        textAlign: 'center',
                        color: COLORS.BLACK,
                      }}
                    >
                      THERE ARE CURRENTLY NO STAFF
                    </Text>
                  </View>
                )}
                {!loading &&
                  offlineUser.length > 0 &&
                  offlineUser.map((user) => (
                    <UserItem
                      user={user}
                      handleCreateChat={(id) => {
                        handleCreateChat(id);
                        setIsModalVisible(false);
                      }}
                    />
                  ))}
              </ScrollView>
            </View>
          </View>
        </View>
      </View>
    </Modal>
  );
};

export default StaffPopup;

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    paddingHorizontal: 40,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
  },
  modalContainer: {
    borderRadius: 10,
    backgroundColor: 'white', // Màu nền của modal (trong suốt)
  },
});
